import { PillVariant } from "../../widget";
import { ColorConstants } from "../styles";

export class ProjectTypeConstants {
  public static readonly PROJECT_TYPE_VARIANT_MAP: { [key: string]: PillVariant } = {
    // Green projects
    "Forestry and Woodland Creation": "green",
    "Hedgerow and Agroforestry": "green",
    Rewilding: "green",
    Biodiversity: "green",

    // Brown projects
    Peatland: "coral",
    "Soil Carbon": "coral",
    "Bio Energy": "coral",
    "Regenerative Agriculture": "coral",

    // Blue projects
    "Seagrass Restoration": "blue",
    "Constructed Wetland": "blue",
    "Saltmarsh Restoration": "blue",
    "Natural Flood Management": "blue",

    // Grey projects
    "Enhanced Weathering": "grey",
    Biochar: "grey",
    "Livestock Feed": "grey",
  };

  public static readonly PROJECT_TYPE_CHART_COLOR_MAP: { [key: string]: string[] } = {
    // Green projects
    "Forestry and Woodland Creation": [ColorConstants.GREEN_500, ColorConstants.GREEN_100],
    "Hedgerow and Agroforestry": [ColorConstants.GREEN_500, ColorConstants.GREEN_100],
    Rewilding: [ColorConstants.GREEN_500, ColorConstants.GREEN_100],
    Biodiversity: [ColorConstants.GREEN_500, ColorConstants.GREEN_100],

    // Brown projects
    Peatland: [ColorConstants.CORAL_500, ColorConstants.CORAL_100],
    "Soil Carbon": [ColorConstants.CORAL_500, ColorConstants.CORAL_100],
    "Bio Energy": [ColorConstants.CORAL_500, ColorConstants.CORAL_100],
    "Regenerative Agriculture": [ColorConstants.CORAL_500, ColorConstants.CORAL_100],

    // Blue projects
    "Seagrass Restoration": [ColorConstants.INDIGO_500, ColorConstants.INDIGO_100],
    "Constructed Wetland": [ColorConstants.INDIGO_500, ColorConstants.INDIGO_100],
    "Saltmarsh Restoration": [ColorConstants.INDIGO_500, ColorConstants.INDIGO_100],
    "Natural Flood Management": [ColorConstants.INDIGO_500, ColorConstants.AQUA_100],

    // Grey projects
    "Enhanced Weathering": [ColorConstants.GREY_500, ColorConstants.GREY_100],
    Biochar: [ColorConstants.GREY_500, ColorConstants.GREY_100],
    "Livestock Feed": [ColorConstants.GREY_500, ColorConstants.GREY_100],
  };

  public static readonly PROJECT_TYPE_PILL_COLOR_MAP: { [key: string]: string[] } = {
    // Green projects
    "Forestry and Woodland Creation": [ColorConstants.GREEN_800, ColorConstants.GREEN_100],
    "Hedgerow and Agroforestry": [ColorConstants.GREEN_800, ColorConstants.GREEN_100],
    Rewilding: [ColorConstants.GREEN_800, ColorConstants.GREEN_100],
    Biodiversity: [ColorConstants.GREEN_800, ColorConstants.GREEN_100],

    // Brown projects
    Peatland: [ColorConstants.CORAL_800, ColorConstants.CORAL_100],
    "Soil Carbon": [ColorConstants.CORAL_800, ColorConstants.CORAL_100],
    "Bio Energy": [ColorConstants.CORAL_800, ColorConstants.CORAL_100],
    "Regenerative Agriculture": [ColorConstants.CORAL_800, ColorConstants.CORAL_100],

    // Blue projects
    "Seagrass Restoration": [ColorConstants.AQUA_800, ColorConstants.AQUA_100],
    "Constructed Wetland": [ColorConstants.AQUA_800, ColorConstants.AQUA_100],
    "Saltmarsh Restoration": [ColorConstants.AQUA_800, ColorConstants.AQUA_100],
    "Natural Flood Management": [ColorConstants.AQUA_800, ColorConstants.AQUA_100],

    // Grey projects
    "Enhanced Weathering": [ColorConstants.GREY_500, ColorConstants.GREY_100],
    Biochar: [ColorConstants.GREY_500, ColorConstants.GREY_100],
    "Livestock Feed": [ColorConstants.GREY_500, ColorConstants.GREY_100],
  };
}
